// Location: src/features/logs/components/LogsPage.tsx
//
// Logs screen — device logs only. The former application-log tabs (processing,
// errors, API calls, search) were removed; the page renders the device logs view
// directly under the standard SectionHeader (filters live in the shared popover).

import { Box } from '@mui/material';
import { SectionHeader } from '@/components/common/SectionHeader';
import { FilterPopoverProvider } from '@/components/common/RaFilterPopover';
import DeviceLogsTab from './DeviceLogsTab';

const LogsPage = () => (
  <FilterPopoverProvider>
    <Box sx={{ p: { xs: 1, sm: 1 } }}>
      {/* Standard header card: the device-logs filters feed the shared popover
          (Filters button) and register Refresh through the context. */}
      <SectionHeader manualScreen="logs" useRaFilters />
      <DeviceLogsTab />
    </Box>
  </FilterPopoverProvider>
);

export default LogsPage;
